import { createFileRoute } from '@tanstack/react-router';

import { batchAssignmentDetailScreen, batchAssignmentDetailSearch, loadBatchAssignmentDetailScreen, loadBatchAssignmentMessages } from '@/modules/batch-assignment/route';
import { lazyScreen } from '@/shared/screen';

// Detalhe da cessão (`router.tsx:1264-1291`); as abas do legado viram `?tab=` (S29).
export const Route = createFileRoute('/_app/ccb/cessoes/$batchAssignmentId/')({
  validateSearch: batchAssignmentDetailSearch,
  staticData: { screen: batchAssignmentDetailScreen },
  loader: loadBatchAssignmentMessages,
  component: lazyScreen(loadBatchAssignmentDetailScreen, 'BatchAssignmentDetailScreen'),
});
